export interface FieldVariable {
	key:   string
	label: string
	group: string
}

export const FIELD_VARIABLES: FieldVariable[] = [
	// ── Основное (из шага «Предмет») ─────────────────────────────────────────
	{ key: 'basics.number',       label: 'Номер договора',              group: 'Договор' },
	{ key: 'basics.dateIso',      label: 'Дата договора',               group: 'Договор' },
	{ key: 'basics.documentType', label: 'Тип документа',               group: 'Договор' },

	// ── Объект аренды ─────────────────────────────────────────────────────────
	{ key: 'subject.objectType',      label: 'Тип объекта',             group: 'Объект аренды' },
	{ key: 'subject.address',         label: 'Адрес',                   group: 'Объект аренды' },
	{ key: 'subject.cadastralNumber', label: 'Кадастровый номер',       group: 'Объект аренды' },
	{ key: 'subject.area',            label: 'Площадь (м²)',            group: 'Объект аренды' },
	{ key: 'subject.purpose',         label: 'Назначение',              group: 'Объект аренды' },

	// ── Арендодатель ──────────────────────────────────────────────────────────
	{ key: 'landlord.organization',  label: 'Название организации',     group: 'Арендодатель' },
	{ key: 'landlord.fullName',      label: 'ФИО подписанта',           group: 'Арендодатель' },
	{ key: 'landlord.inn',           label: 'ИНН',                      group: 'Арендодатель' },
	{ key: 'landlord.ogrn',          label: 'ОГРН / ОГРНИП',           group: 'Арендодатель' },
	{ key: 'landlord.legalAddress',  label: 'Юридический адрес',        group: 'Арендодатель' },
	{ key: 'landlord.bankAccountId', label: 'Банковский счёт',          group: 'Арендодатель' },
	{ key: 'landlord.signatoryId',   label: 'Подписант',                group: 'Арендодатель' },

	// ── Арендатор ─────────────────────────────────────────────────────────────
	{ key: 'tenant.contragentName',      label: 'ФИО / Название',        group: 'Арендатор' },
	{ key: 'tenant.tenantType',          label: 'Тип арендатора',         group: 'Арендатор' },
	{ key: 'tenant.phone',               label: 'Телефон',                group: 'Арендатор' },
	{ key: 'tenant.registrationAddress', label: 'Адрес регистрации',      group: 'Арендатор' },
	{ key: 'tenant.passportSeries',      label: 'Серия паспорта',         group: 'Арендатор' },
	{ key: 'tenant.passportNumber',      label: 'Номер паспорта',         group: 'Арендатор' },
	{ key: 'tenant.passportIssuedBy',    label: 'Кем выдан паспорт',      group: 'Арендатор' },
	{ key: 'tenant.inn',                 label: 'ИНН',                    group: 'Арендатор' },
	{ key: 'tenant.ogrn',                label: 'ОГРН / ОГРНИП',          group: 'Арендатор' },
	{ key: 'tenant.kpp',                 label: 'КПП',                    group: 'Арендатор' },
	{ key: 'tenant.bank',                label: 'Банк',                   group: 'Арендатор' },
	{ key: 'tenant.bankAccount',         label: 'Расчётный счёт',         group: 'Арендатор' },
	{ key: 'tenant.corrAccount',         label: 'Корр. счёт',             group: 'Арендатор' },
	{ key: 'tenant.bic',                 label: 'БИК',                    group: 'Арендатор' },

	// ── Арендатор — доверенность ─────────────────────────────────────────────
	{ key: 'tenant.signatoryId',        label: 'Представитель по доверенности', group: 'Арендатор' },
	{ key: 'tenant.baseDocumentNumber', label: 'Номер доверенности',            group: 'Арендатор' },
	{ key: 'tenant.validFromIso',       label: 'Доверенность действует с',      group: 'Арендатор' },
	{ key: 'tenant.validToIso',         label: 'Доверенность действует по',     group: 'Арендатор' },
	{ key: 'display.tenant.proxyClause',label: 'Оговорка о доверенности',       group: 'Арендатор' },

	// ── Срок и условия ────────────────────────────────────────────────────────
	{ key: 'terms.contractFromIso',  label: 'Дата начала договора',      group: 'Срок и условия' },
	{ key: 'terms.contractToIso',    label: 'Дата окончания договора',   group: 'Срок и условия' },
	{ key: 'terms.effectiveFromIso', label: 'Дата вступления в силу',    group: 'Срок и условия' },
	{ key: 'terms.otherConditions',  label: 'Прочие условия (свободный текст)', group: 'Срок и условия' },

	// ── Срок и условия — форматированные ─────────────────────────────────────
	{ key: 'display.terms.rentTermKind',      label: 'Тип договора (определённый / неопределённый)', group: 'Срок и условия' },
	{ key: 'display.terms.landlordNotice',    label: 'Срок уведомления арендодателя',                group: 'Срок и условия' },
	{ key: 'display.terms.tenantNotice',      label: 'Срок уведомления арендатора',                  group: 'Срок и условия' },
	{ key: 'display.terms.transferMode',      label: 'Способ передачи помещения',                    group: 'Срок и условия' },
	{ key: 'display.terms.transferActPeriod', label: 'Срок передачи помещения',                      group: 'Срок и условия' },
	{ key: 'display.terms.transferActTiming', label: 'Момент передачи (после чего)',                 group: 'Срок и условия' },
	{ key: 'display.terms.transferMoment',    label: 'Момент перехода пользования',                  group: 'Срок и условия' },
	{ key: 'display.terms.returnMode',        label: 'Способ возврата помещения',                    group: 'Срок и условия' },
	{ key: 'display.terms.returnPeriod',      label: 'Срок возврата помещения',                      group: 'Срок и условия' },
	{ key: 'display.terms.returnTiming',      label: 'Момент возврата (после чего)',                 group: 'Срок и условия' },
	{ key: 'display.terms.returnConditions',  label: 'Условия возврата (перечень)',                  group: 'Срок и условия' },
	{ key: 'display.terms.improvementsFate',  label: 'Судьба неотделимых улучшений',                 group: 'Срок и условия' },

	// ── Платежи ───────────────────────────────────────────────────────────────
	{ key: 'payments.rentAmount',    label: 'Арендная плата',            group: 'Платежи' },
	{ key: 'payments.rentCurrency',  label: 'Валюта',                    group: 'Платежи' },
	{ key: 'payments.rentVatRate',   label: 'Ставка НДС (%)',            group: 'Платежи' },
	{ key: 'payments.depositAmount', label: 'Обеспечительный платёж',    group: 'Платежи' },
	{ key: 'payments.depositTermCount', label: 'Срок возврата депозита', group: 'Платежи' },
	{ key: 'payments.penaltyPercent',   label: 'Пеня за просрочку (%)', group: 'Платежи' },

	// ── Платежи — форматированные ─────────────────────────────────────────────
	{ key: 'display.payments.vatClause',          label: 'НДС (включён / не облагается)',            group: 'Платежи' },
	{ key: 'display.payments.paymentForm',         label: 'Форма оплаты',                            group: 'Платежи' },
	{ key: 'display.payments.paymentDay',          label: 'День оплаты',                             group: 'Платежи' },
	{ key: 'display.payments.periodStart',         label: 'Начало расчётного периода',               group: 'Платежи' },
	{ key: 'display.payments.firstPaymentPeriod',  label: 'Срок первого платежа',                    group: 'Платежи' },
	{ key: 'display.payments.depositClause',       label: 'Депозит (сумма или "не предусмотрен")',   group: 'Платежи' },
	{ key: 'display.payments.depositTermPeriod',   label: 'Срок возврата депозита',                  group: 'Платежи' },
	{ key: 'display.payments.depositTiming',       label: 'Момент возврата депозита (после чего)',   group: 'Платежи' },
	{ key: 'display.payments.depositReturn',       label: 'Порядок возврата депозита',               group: 'Платежи' },
	{ key: 'display.payments.penaltyGrace',        label: 'Льготный период пени',                    group: 'Платежи' },
]

/** Table variables — array fieldKeys that render as pdfmake tables in the PDF. */
export interface TableVariable {
	key:   string
	label: string
}

export const TABLE_VARIABLES: TableVariable[] = [
	{ key: 'subject.services',   label: 'Таблица доп. услуг' },
	{ key: 'payments.utilities', label: 'Таблица коммунальных услуг' },
]

export const TABLE_VARIABLES_BY_KEY = Object.fromEntries(
	TABLE_VARIABLES.map((v) => [v.key, v])
) as Record<string, TableVariable>

export const FIELD_VARIABLES_BY_KEY = Object.fromEntries(
	FIELD_VARIABLES.map((v) => [v.key, v])
) as Record<string, FieldVariable>

export const FIELD_VARIABLE_GROUPS = [...new Set(FIELD_VARIABLES.map((v) => v.group))]

/** Resolve a dotted key against a nested object (e.g. 'subject.address' → data.subject.address). */
export function resolveFieldKey(data: Record<string, unknown>, key: string): string {
	const parts = key.split('.')
	let current: unknown = data
	for (const part of parts) {
		if (current === null || current === undefined || typeof current !== 'object') return ''
		current = (current as Record<string, unknown>)[part]
	}
	if (current === null || current === undefined) return ''
	return String(current)
}
